import React from 'react';

import { useIntl } from 'react-intl-next';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';

import messages from '../../../common/messages';
import { PreviewPanelAction } from '../../../common/ui/preview-panel-action';

import { type PreviewPanelNewTabLinkProp } from './types';

export const PreviewPanelNewTabLink = ({
	href,
	label,
	onClick,
	testId,
	analyticsContext,
}: PreviewPanelNewTabLinkProp): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<PreviewPanelAction
			label={label || formatMessage(messages.previewPanelNewTabActionLabel)}
			icon={LinkExternalIcon}
			onClick={onClick}
			href={href}
			testId={testId}
			analyticsContext={analyticsContext}
		/>
	);
};
